import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import BubbleContent from '../content/bubble_content';
import Communicator from 'models/communicator';
import ConversationItem from 'models/conversation_item';
import { formatPhoneNumber } from 'models/phone_number';
import InlineAnnotatedContentContainer from 'components/lib/inline_annotated_content_container';
import ItemCommError from '../item_comm_error';
import ItemContent from '../item_content';
import ItemMetadata from '../item_metadata';
import SmsMessageAttachments from './attachments/sms_message_attachments';
import { STATUS as SmsStatus } from 'models/sms_message';

export default function SmsItem({ className, isFirstInStack, isLastInStack, isStacked, item }) {
  const tooltip = `sent from ${formatPhoneNumber(item.content.from)} to ${formatPhoneNumber(item.content.to)}`;

  return (
    <ItemContent
      isFirstInStack={isFirstInStack}
      isLastInStack={isLastInStack}
      isStacked={isStacked}
      item={item}
      showIcon={!isStacked}
    >
      <ItemMetadata item={item} showMetadata={!isStacked} status={getStatus()} tooltip={tooltip} />
      <SmsContent className={className} item={item} />
      <ItemCommError item={item} />
    </ItemContent>
  );

  function getStatus() {
    const status = item.content.getStatus();
    switch (status) {
      case SmsStatus.DELIVERED:
        return 'delivered';
      case SmsStatus.SENT:
        return 'sent';
      case SmsStatus.FAILED:
      case SmsStatus.UNDELIVERED:
      case SmsStatus.UNKNOWN:
        return 'delivery failed';
      case SmsStatus.NEW:
      case SmsStatus.SENDING:
        return 'sending';
      case SmsStatus.RECEIVED:
        return 'received';
      default:
        return undefined;
    }
  }
}

SmsItem.propTypes = {
  className: PropTypes.string,
  isFirstInStack: PropTypes.bool,
  isLastInStack: PropTypes.bool,
  isStacked: PropTypes.bool,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

export function SmsContent({ className, item }) {
  const isAutoreply = item.initiator.type === Communicator.AUTOMATED;
  return (
    <BubbleContent className={classnames('smsItem-content', className)} item={item}>
      {isAutoreply ? <div className="smsItem-autoreply">Autoreply</div> : null}
      <InlineAnnotatedContentContainer
        hasRedactedPaymentCard={item.content.hasRedactedPaymentCardNumber}
        id={item.id}
        text={item.content.body}
      />
      <SmsMessageAttachments attachments={item.content.attachments || []} />
    </BubbleContent>
  );
}

SmsContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/sms/sms_item.jsx